import { Link } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  ActionTypeCode,
  InformationRequestAction,
} from "../../../domain/InformationRequestAction";
import {
  postMarkResponseComplete,
  postMarkUploadComplete,
  postReadDocuments,
} from "../../../redux/actions";

export const MarkDocumentsAsReadLink: React.FC<{
  className: string;
  action: InformationRequestAction;
  organisationRecipientId: string;
  actionTypeCode: any;
}> = ({ className, action, organisationRecipientId, actionTypeCode }) => {
  const dispatch = useDispatch();
  const { itemId } = useParams<{
    itemId: string;
  }>();

  const handleClick = () => {
    if (actionTypeCode === ActionTypeCode.ReadDocument) {
      dispatch(
        postReadDocuments(
          action.informationRequestId,
          organisationRecipientId,
          itemId,
          action.id
        )
      );
    } else if (actionTypeCode === ActionTypeCode.SendMessage) {
      dispatch(
        postMarkResponseComplete(
          action.informationRequestId,
          organisationRecipientId,
          itemId,
          action.id
        )
      );
    } else if (actionTypeCode === ActionTypeCode.UploadDocument) {
      dispatch(
        postMarkUploadComplete(
          action.informationRequestId,
          organisationRecipientId,
          itemId,
          action.id
        )
      );
    }
  };

  return (
    <Link component="button" className={className} onClick={handleClick}>
      Mark as complete
    </Link>
  );
};
